<div class="otp-component">
  <div>
    <!-- <form [formGroup]="form"> -->
    <form [formGroup]="form" (ngSubmit)="onFormSubmit($event)">
      <div class="form-group">
        <label for="contactInfo" class="contactInfoLabel">{{allowEmail && allowMobile ?
          finalResources.contactInfoInputLabel :
          (allowEmail ? finalResources.contactInfoEmailInputLabel :
          finalResources.contactInfoMobileInputLabel)}}</label>
        <div class="input-with-icon">
          <input id="contactInfo" #contactInfoInput type="text" formControlName="contactInfo" class="form-control"
            [placeholder]="allowEmail && allowMobile ? finalResources.contactInfoInputPlaceholder :
             (allowEmail ? finalResources.contactInfoEmailInputPlaceholder : finalResources.contactInfoMobileInputPlaceholder)"
            [ngClass]="{'is-invalid': form.get('contactInfo')?.invalid && form.get('contactInfo')?.dirty}"
            [disabled]="form.get('contactInfo')?.disabled ?? false" />
          <!-- Edit Icon (Positioned to the right) -->
          <span *ngIf="form?.get('contactInfo')?.disabled" (click)="onEdit()" class="edit-icon">
            ✏️
          </span>
        </div>
        <!-- Error Messages for contact info -->
        <div *ngIf="hasError('contactInfo', 'required')" class="error-message">
          {{allowEmail && allowMobile ? finalResources.contactInfoRequiredErrorMessage : (allowEmail ?
          finalResources.emailRequiredErrorMessage : finalResources.mobileRequiredErrorMessage)}}
        </div>
        <div *ngIf="hasError('contactInfo', 'invalidContact')" class="error-message">
          {{allowEmail && allowMobile ? finalResources.contactInfoInvalidErrorMessage : (allowEmail ?
          finalResources.emailInvalidErrorMessage : finalResources.mobileInvalidErrorMessage)}}
        </div>
      </div>

      <!-- Hide Get OTP Button after clicking -->
      <button *ngIf="!isOtpVisible" type="submit" [disabled]="form.get('contactInfo')?.invalid"
        class="submit-button full-width">
        {{ finalResources.getOtpButtonLabel }}
      </button>

      <!-- OTP Form Displayed After Contact Validation -->
      <div *ngIf="isOtpVisible">
        <div class="form-group">
          <label for="otp">{{ finalResources.otpInputLabel }}</label>
          <input id="otp" #otpInput type="text" formControlName="otp" class="form-control" autocomplete="off"
            [placeholder]="finalResources.otpInputPlaceholder" (keydown)="onOtpInputKeyDown($event)" (paste)="onPaste($event)" (input)="onOTPInput($event)"
            [ngClass]="{'is-invalid': form.get('otp')?.invalid && form.get('otp')?.touched}" />
          <div *ngIf="hasError('otp', 'required')" class="error-message">
            {{ finalResources.otpRequiredErrorMsg }}
          </div>
          <div *ngIf="form.get('otp')?.hasError('pattern')" class="error-message">
            {{ finalResources.otpPatternErrorMsg}}
          </div>
        </div>

        <!-- Timer Display -->
        <div class="timer-message">
          {{finalResources.otpExpiresInMsg}} {{ otpTimer }} seconds
        </div>

        <!-- Submit OTP Button -->
        <button type="button" otpSubmitButton [disabled]="!isOtpValid()" class="submit-button full-width"
          (click)="onSubmitOtp()">
          {{finalResources.submitOtpButtonLabel}}
        </button>
      </div>
    </form>
  </div>
</div>